import { FC, ReactElement } from 'react'
import { StyleHeading, StyleLink } from './style'
import Row from '@components/row'
import { colors } from '@utils/theme'
interface CardHeadingProps {
  title: string
  tc?: keyof typeof colors
  hasView?: boolean
  path?: string
  titleRightComponent?: ReactElement
}
const CardHeading: FC<CardHeadingProps> = ({
  title,
  titleRightComponent,
  tc = 'text',
  hasView = false,
  path,
}) => {
  return (
    <Row justifyContent="space-between" alignItems="center">
      <StyleHeading tc={tc}>
        {title} {titleRightComponent && titleRightComponent}
      </StyleHeading>
      {!!hasView && <StyleLink to={path}>View All</StyleLink>}
    </Row>
  )
}

export default CardHeading
